import React, { Component } from "react";
import { Button, Card } from "@blueprintjs/core";
import { Link } from "react-router-dom";

class LandingPage extends Component {
  render() {
    return (
      <div style={{ maxWidth: 700, margin: "3rem auto", padding: "1rem" }}>
        <Card elevation={2}>
          <h1>Mister Coach</h1>
          <p>
            Platformă modernă pentru antrenorii de fotbal: gestionează echipe, planifică antrenamente,
            vizualizează formații și analizează jucători. Simplu, rapid și eficient.
          </p>

          <div style={{ marginTop: "2rem" }}>
            <Link to="/signup">
              <Button intent="primary" large style={{ marginRight: 12 }}>
                Creează cont
              </Button>
            </Link>
            <Link to="/login">
              <Button large>Autentificare</Button>
            </Link>
          </div>
        </Card>
      </div>
    );
  }
}

export default LandingPage;
